"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleSignalDriveModeSchema = exports.__ModuleDriveModeSchemaInternal = void 0;
const zod_1 = require("zod");
const ExpressionVariableValues_1 = require("./ExpressionVariableValues");
exports.__ModuleDriveModeSchemaInternal = zod_1.z.object({
    moduleId: zod_1.z.string(),
    signalId: zod_1.z.string().nullable(),
    driveType: zod_1.z.string().nullable(),
    driveModeConditionNames: zod_1.z.array(zod_1.z.string()).nullable().optional(),
    outputHighVoltageDetails: ExpressionVariableValues_1.ExpressionDetailsSchema.nullable(),
    outputLowVoltageDetails: ExpressionVariableValues_1.ExpressionDetailsSchema.nullable(),
    inputHighVoltageDetails: ExpressionVariableValues_1.ExpressionDetailsSchema.nullable(),
    inputLowVoltageDetails: ExpressionVariableValues_1.ExpressionDetailsSchema.nullable(),
    modeActiveState: zod_1.z.string().nullable(),
    traversalNetName: zod_1.z.string().optional(),
    traversalPaths: zod_1.z.array(zod_1.z.string()).optional(),
});
exports.ModuleSignalDriveModeSchema = zod_1.z.preprocess((data) => {
    if (typeof data === 'object' && data !== null && 'driveModeContidionNames' in data) {
        const record = data;
        record.driveModeConditionNames = record.driveModeContidionNames;
        delete record.driveModeContidionNames;
    }
    return data;
}, exports.__ModuleDriveModeSchemaInternal);
//# sourceMappingURL=ModuleSignalDriveMode.js.map